document.addEventListener('DOMContentLoaded', function() {

    initDynamicColors();
    initHeader();
    window.addEventListener('scroll', initHeader);

    const mainMenus = document.querySelectorAll('#ast-hf-menu-1-sticky, #ast-hf-menu-1');

    mainMenus.forEach(function(menu) {

        const closeButton = menu.querySelector('.menu-item-close-button');
        const openButton = menu.querySelector('.menu-item-open-button');

        if ( ! closeButton || ! openButton ) return;
        
        closeButton.addEventListener('click', function() {
            document.body.classList.remove('has-open-menu');
        });

        openButton.addEventListener('click', function() {
            document.body.classList.add('has-open-menu');
        });

    });

    document.querySelectorAll('.wp-block-velthuizen-social-share').forEach(function(shareBlock) {

        const shareButton = shareBlock.querySelector('.social-share__button');
        const shareButtonText = shareButton.querySelector('span');
        const shareButtonLabels = [
            shareButton.innerHTML,
            shareButton.getAttribute('data-text-open'),
        ];

        shareButton.addEventListener('click', function() {

            shareBlock.classList.toggle('is-open');
            shareButtonText.innerHTML = shareButtonLabels[shareBlock.classList.contains('is-open') ? 1 : 0];
            shareBlock.querySelector('#social-share-platforms').setAttribute('aria-hidden', shareBlock.classList.contains('is-open') ? 'false' : 'true');
            shareButton.setAttribute('aria-expanded', shareBlock.classList.contains('is-open') ? 'true' : 'false');

        });

    });

    document.querySelectorAll('.velthuizen-offcanvas__toggle').forEach(function(toggle) {
        const offcanvas = document.querySelector('#filter-offcanvas');
        const offcanvasInner = offcanvas.querySelector('.velthuizen-offcanvas__inner');

        toggle.addEventListener('click', function() {
            const isHidden = offcanvas.classList.contains('velthuizen-offcanvas--hidden');
            offcanvas.classList.toggle('velthuizen-offcanvas--hidden');
            offcanvas.setAttribute('aria-hidden', !isHidden);
            
            if (!isHidden) {
                toggle.setAttribute('aria-expanded', 'false');
            } else {
                toggle.setAttribute('aria-expanded', 'true');
                offcanvasInner.focus();
            }
        });
    });

    const offcanvas = document.querySelector('#filter-offcanvas');
    if(offcanvas) {
      const closeButton = offcanvas.querySelector('.velthuizen-offcanvas__close');

      offcanvas.addEventListener('click', function(event) {
          if (event.target === offcanvas) {
              closeOffcanvas();
          }
      });

      closeButton.addEventListener('click', closeOffcanvas);
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && !offcanvas.classList.contains('velthuizen-offcanvas--hidden')) {
            closeOffcanvas();
        }
    });

    function closeOffcanvas() {
        offcanvas.classList.add('velthuizen-offcanvas--hidden');
        offcanvas.setAttribute('aria-hidden', 'true');
        document.querySelector('.velthuizen-offcanvas__toggle').setAttribute('aria-expanded', 'false');
    }

    jQuery(document).on('facetwp-loaded', function() {
        jQuery('.facetwp-facet').each(function() {
          var facet = $(this);
          var facet_name = facet.attr('data-name');
          var facet_type = facet.attr('data-type');
          var facet_label = FWP.settings.labels[facet_name];
          if ( ! ['pager','sort','reset'].includes( facet_type ) ) { // Add or remove excluded facet types to/from the array
            if (facet.closest('.facet-wrap').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
              facet.wrap('<div class="facet-wrap"></div>');
              facet.before('<h3 class="facet-label has-body-large-font-size">' + facet_label + '</h3>');
            }
          }
        });
    });

    document.addEventListener('facetwp-loaded', function() {

      initFacetWp();

    });

    initKeenSliders();

});

function addKeenSliderNavigation(slider) {

    let dots, arrowLeft, arrowRight;
  
    function markup(remove) {
      dotMarkup(remove);
      arrowMarkup(remove);
    }
  
    function removeElement(element) {
      element.parentNode.removeChild(element);
    }
  
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }
  
    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      
      arrowLeft = createDiv("post-slider__arrow post-slider__arrow--left icon-arrow-left");
      arrowLeft.setAttribute("role", "button");
      arrowLeft.setAttribute("aria-label", "Previous slide");
      arrowLeft.setAttribute("tabindex", "0");
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowLeft.addEventListener("keydown", (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          slider.prev();
        }
      });
  
      arrowRight = createDiv("post-slider__arrow post-slider__arrow--right icon-arrow-right");
      arrowRight.setAttribute("role", "button");
      arrowRight.setAttribute("aria-label", "Next slide");
      arrowRight.setAttribute("tabindex", "0");
      arrowRight.addEventListener("click", () => slider.next());
      arrowRight.addEventListener("keydown", (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          slider.next();
        }
      });
  
      slider.container.parentNode.appendChild(arrowLeft);
      slider.container.parentNode.appendChild(arrowRight);
    }
  
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv("post-slider__dots");
      dots.setAttribute("role", "tablist");
  
      const totalSlides = slider.track.details.slides.length;
      const slidesPerView = getSlidesPerView();
      const dotCount = Math.ceil(totalSlides / slidesPerView);
  
      for (let idx = 0; idx < dotCount; idx++) {
        var dot = createDiv("post-slider__dot");
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", `Slide group ${idx + 1}`);
        dot.setAttribute("tabindex", "0");
        dot.addEventListener("click", () => {
          const targetIndex = Math.min(idx * slidesPerView, totalSlides - slidesPerView);
          slider.moveToIdx(targetIndex);
        });
        dot.addEventListener("keydown", (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            const targetIndex = Math.min(idx * slidesPerView, totalSlides - slidesPerView);
            slider.moveToIdx(targetIndex);
          }
        });
        dots.appendChild(dot);
      }
  
      slider.container.parentNode.appendChild(dots);
    }
  
    function updateClasses() {
      var slide = slider.track.details.rel;
      var totalSlides = slider.track.details.slides.length;
      var slidesPerView = getSlidesPerView();
      
      slide === 0
        ? arrowLeft.classList.add("post-slider__arrow--disabled")
        : arrowLeft.classList.remove("post-slider__arrow--disabled");
      slide >= totalSlides - slidesPerView
        ? arrowRight.classList.add("post-slider__arrow--disabled")
        : arrowRight.classList.remove("post-slider__arrow--disabled");
      
      var activeDotIndex = Math.floor(slide / slidesPerView);
      Array.from(dots.children).forEach(function(dot, idx) {
        if (idx === activeDotIndex) {
          dot.classList.add("post-slider__dot--active");
          dot.setAttribute("aria-selected", "true");
        } else {
          dot.classList.remove("post-slider__dot--active");
          dot.removeAttribute("aria-selected");
        }
      });
    }
  
    function getSlidesPerView() {
      return window.innerWidth <= 686 ? 1 : slider.options.slides.perView;
    }
  
    slider.on("created", () => {
      markup();
      updateClasses();
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
    
    window.addEventListener('resize', () => {
      markup(true);
      markup();
      updateClasses();
    });
}

function initDynamicColors() {
    const colorSlugs = ['white', 'lighter', 'light', 'orange', 'yellow', 'dark', 'black', 'green', 'gold'];
    const body = document.body;
    const sections = [
        ...document.querySelectorAll('.entry-content .wp-block-group.alignfull'),
        ...document.querySelectorAll('[class*="astra-advanced-hook-"] .wp-block-group.alignfull'),
        ...document.querySelectorAll('[class*="astra-advanced-hook-"] .entry-content .wp-block-group.alignfull')
    ];

    const defaultPalette = {
        text: 'black',
        heading: 'dark',
        link: 'orange',
        link_hover: '#b8623c',
        label: 'orange',
        border: 'rgba(0, 0, 0, 0.1)',
        shape: '#E1D8CD',
        image_filter: 'grayscale(100%)'
    };

    const colorPalette = {
        white: {},
        lighter: {},
        light: { shape: '#eee7df' },
        orange: {
            text: 'white',
            heading: 'white',
            link: 'white',
            link_hover: 'rgba(255, 255, 255, 0.8)',
            label: 'white',
            border: 'rgba(255, 255, 255, 0.1)',
            shape: 'rgba(256, 256, 256, 0.15)',
            image_filter: 'grayscale(100%) invert()'
        },
        dark: {
            text: 'white',
            heading: 'white',
            link: 'white',
            link_hover: 'rgba(255, 255, 255, 0.8)',
            border: 'rgba(256, 256, 256, 0.15)',
            shape: 'rgba(256, 256, 256, 0.15)',
            image_filter: 'grayscale(100%) invert()'
        },
        black: {
            text: 'white',
            heading: 'white',
            link: 'white',
            link_hover: 'rgba(255, 255, 255, 0.8)',
            border: 'rgba(256, 256, 256, 0.15)',
            shape: 'rgba(256, 256, 256, 0.15)',
            image_filter: 'grayscale(100%) invert()'
        },
        yellow: { shape: 'rgba(256, 256, 256, 0.15)' },
        green: { shape: 'rgba(256, 256, 256, 0.15)' },
        gold: { shape: 'rgba(256, 256, 256, 0.15)' }
    };

    function getColorSlug(element) {
        return element.className.match(/has-([\w-]+)-background-color/)?.[1] || 'lighter';
    }

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
    }

    function updateBodyColor() {
        const visibleSection = sections.find(isElementInViewport);        
        
        if (visibleSection) {
            const newColorSlug = getColorSlug(visibleSection);
            body.classList.remove(...colorSlugs.map(slug => `has-body-${slug}-background-color`));            
            if (newColorSlug !== 'lighter' && (window.pageYOffset > 0 || visibleSection !== sections[sections.length - 1])) {
                const colors = { ...defaultPalette, ...colorPalette[newColorSlug] };
                body.style.setProperty('--velthuizen-background-color', `var(--wp--preset--color--${newColorSlug})`);
                body.style.setProperty('--velthuizen-text-color', `var(--wp--preset--color--${colors.text})`);
                body.style.setProperty('--velthuizen-link-color', `var(--wp--preset--color--${colors.link})`);
                body.style.setProperty('--velthuizen-link-hover-color', colors.link_hover);
                body.style.setProperty('--velthuizen-heading-color', `var(--wp--preset--color--${colors.heading})`);
                body.style.setProperty('--velthuizen-border-color', colors.border);
                body.style.setProperty('--velthuizen-shape-color', colors.shape);
                body.style.setProperty('--velthuizen-image-filter', colors.image_filter);
                body.classList.add('has-body-overwrite-background-color');
                body.classList.add(`has-body-${newColorSlug}-background-color`);
            } else {
                resetColors();
            }
        } else {
            resetColors();
        }
    }

    function resetColors() {
        body.classList.remove(...colorSlugs.map(slug => `has-body-${slug}-background-color`), 'has-body-overwrite-background-color');
        body.style.setProperty('--velthuizen-background-color', `var(--wp--preset--color--${defaultPalette.background || 'lighter'})`);
        body.style.setProperty('--velthuizen-text-color', `var(--wp--preset--color--${defaultPalette.text})`);
        body.style.setProperty('--velthuizen-link-color', `var(--wp--preset--color--${defaultPalette.link})`);
        body.style.setProperty('--velthuizen-link-hover-color', defaultPalette.link_hover);
        body.style.setProperty('--velthuizen-heading-color', `var(--wp--preset--color--${defaultPalette.heading})`);
        body.style.setProperty('--velthuizen-border-color', defaultPalette.border);
        body.style.setProperty('--velthuizen-shape-color', defaultPalette.shape);
        body.style.setProperty('--velthuizen-image-filter', defaultPalette.image_filter);
    }

    window.addEventListener('scroll', updateBodyColor);
    window.addEventListener('resize', updateBodyColor);
    updateBodyColor(); // Initial call
}

function initFacetWp() {
    if (window.location.search.includes('scroll=true')) {
        const grid = document.querySelector('.wp-block-velthuizen-post-grid:has(.facetwp-template)');
        if (grid) {
            grid.scrollIntoView({ behavior: 'smooth', offsetTop: 100 });
        }
        const newUrl = window.location.href.replace(/&?scroll=true&?/, '');
        window.history.replaceState(null, null, newUrl);
    }

    jQuery.each(FWP.settings.num_choices, function(key, val) {
        var $facet = $('.facetwp-facet-' + key);
        var $wrap = $facet.closest('.facet-wrap');
        var $flyout = $facet.closest('.flyout-row');
        if ($wrap.length || $flyout.length) {
            var $which = $wrap.length ? $wrap : $flyout;
            (0 === val) ? $which.hide() : $which.show();
        }
    });

    // Wacht even voordat de sliders opnieuw worden geïnitialiseerd
    setTimeout(() => {
        initKeenSliders();
        updateLoadMoreSlide();
    }, 100);

    document.querySelectorAll('.velthuizen-offcanvas__footer .wp-block-button__link').forEach(function(button) {
        const numberOfResults = FWP.settings.pager.total_rows;
        button.innerHTML = numberOfResults > 1 ? numberOfResults + ' resultaten bekijken' : numberOfResults + ' resultaat bekijken';
    });
}

function updateLoadMoreSlide() {
    document.querySelectorAll('.wp-block-velthuizen-post-grid .keen-slider').forEach((slider) => {
        const loadMoreSlides = slider.querySelectorAll('.keen-slider__slide[data-slide-type="load-more"]');
        
        for (let i = 0; i < loadMoreSlides.length - 1; i++) {
            loadMoreSlides[i].remove();
        }

        if (loadMoreSlides.length > 0) {
            const lastLoadMoreSlide = loadMoreSlides[loadMoreSlides.length - 1];
            slider.appendChild(lastLoadMoreSlide);
        }
    });
}

function initKeenSliders() {
    document.querySelectorAll('.wp-block-velthuizen-post-grid .keen-slider').forEach((el, i) => {
        let currentSlide = 0;
        if (el.keenSlider) {
            currentSlide = el.keenSlider.track.details.rel;
            el.keenSlider.destroy();
        }

        const columns = getComputedStyle(el.parentNode).getPropertyValue('--columns');
  
        let slider = new KeenSlider(el, {
            breakpoints: {
                "(max-width: 686px)": {
                    slides: { perView: 1 },
                }
            },
            slides: {
                perView: columns,
                spacing: 0,
            },
            initial: currentSlide,
        }, [addKeenSliderNavigation]);

        el.keenSlider = slider;
    });
}

function initHeader() {

  let mainMenuWidth = document.querySelector('.ast-main-header-bar-alignment').getBoundingClientRect().width + 245;
  let slideSearch = document.querySelector('.slide-search');
  slideSearch.style.setProperty('--min-width', `${mainMenuWidth}px`);

}
